import React from 'react';
import PropTypes from 'prop-types';

import { bookingShape, userShape } from 'constants/propTypes';
import { Page, Row } from 'components/shared/Layout';
import Payments from 'components/ui/Payments';

const RefundMethods = ({ booking, currency }) => (
  <Page>
    <Row span={14} start={2}>
      <Payments
        type="refund"
        reference={booking.reference}
        currency={currency}
        status={booking.status}
        totalPriceToBePaid={booking.totalPriceToBePaid}
        payments={booking.payments}
        refunds={booking.refunds}
        customer={booking.customer}
        notes={booking.notes}
        isPackage={booking.isPackage}
        hotels={booking.hotels}
        outbound={booking.outbound}
        inbound={booking.inbound}
        passengers={booking.passengers}
        additionalDetails={booking.additionalDetails || []}
        isGroup={booking.isGroupBooking}
      />
    </Row>
  </Page>
);

RefundMethods.propTypes = {
  booking: bookingShape,
  currency: PropTypes.string,
  user: userShape,
  onCurrencyChange: PropTypes.func.isRequired
};

export default RefundMethods;
